import { useMemo, useState } from "react";

import { TextField } from "@portex-pro/ui-components";
import PortexDialog from "components/PortexDialog";
import Text from "components/Text";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useTermsAndConditionsDialog = (termsAndConditions: string | undefined, onConfirm: () => void) => {
  const [open, setOpen] = useState(false);

  const openDialog = () => {
    if (termsAndConditions) {
      setOpen(true);
    } else {
      onConfirm();
    }
  };

  const handleConfirm = useMemo(
    () => () => {
      onConfirm();
      setOpen(false);
    },
    [setOpen, onConfirm]
  );

  const TermsAndConditionsDialogElement = useMemo(
    () => (
      <PortexDialog
        open={open}
        title={"Terms and Conditions"}
        onClose={() => setOpen(false)}
        onClickConfirm={handleConfirm}
      >
        <div className="flex flex-col p-4 space-y-4">
          <Text size="medium" weight="bold">
            By submitting rates you are agreeing to the shipper's Terms and Conditions:
          </Text>

          <TextField value={termsAndConditions} disabled rows={5} rowsMax={10} multiline />
        </div>
      </PortexDialog>
    ),
    [open, termsAndConditions, handleConfirm]
  );

  return { TermsAndConditionsDialogElement, openDialog };
};
